import { v4 as uuid } from 'uuid';
export type TempRegField = { field: string | number; value: string; id: string };

export const filterOutValidFields = (tempField: TempRegField) => !(tempField.field && tempField.value.trim());
export const fieldObjectToFieldId = (tempField: TempRegField) => tempField.field.toString();
export const fieldsToArray = (
  fields: Record<string, string>,
  defaultField: string,
  existingQuestions?: boolean
): TempRegField[] => {
  if (Object.keys(fields).length) {
    return Object.entries(fields).map(([key, value]) => ({
      field: existingQuestions ? Number(key) : key,
      value,
      id: uuid(),
    }));
  } else {
    return [{ field: defaultField, value: '', id: uuid() }];
  }
};
export const getDuplicates = (regFieldsTemp: TempRegField[]) => {
  const countMap: Map<string, number> = new Map();
  const setIds = regFieldsTemp.map((tempField) => String(tempField.field));
  setIds.forEach((id) => countMap.set(id, (countMap.get(id) ?? 0) + 1));
  const duplicates: string[] = [];

  for (const [field, count] of countMap.entries()) {
    if (count > 1) {
      duplicates.push(field);
    }
  }

  return duplicates;
};
